import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c6ed1e04"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  style: {"display":"flex"},
  class: "avatar"
}
const _hoisted_2 = { class: "avatar-left" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "支持jpg、png格式的图片，大小不超过3M", -1))
const _hoisted_4 = { class: "avatar-left-crop" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "avatar-left-p" }, " 鼠标滚轮缩放控制图片显示大小，鼠标拖拽调整显示位置 ", -1))
const _hoisted_6 = { class: "avatar-right" }
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "avatar-right-text" }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { class: "header-box" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "header-title" }, "推荐头像", -1))
const _hoisted_12 = { class: "header-list" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: "/static/free/header/1.png" }, null, -1))
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: "/static/free/header/2.png" }, null, -1))
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: "/static/free/header/3.png" }, null, -1))
const _hoisted_18 = [
  _hoisted_17
]
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: "/static/free/header/4.png" }, null, -1))
const _hoisted_20 = [
  _hoisted_19
]
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: "/static/free/header/5.png" }, null, -1))
const _hoisted_22 = [
  _hoisted_21
]
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: "/static/free/header/6.png" }, null, -1))
const _hoisted_24 = [
  _hoisted_23
]
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: "/static/free/header/7.png" }, null, -1))
const _hoisted_26 = [
  _hoisted_25
]
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: "/static/free/header/8.png" }, null, -1))
const _hoisted_28 = [
  _hoisted_27
]
const _hoisted_29 = {
  slot: "footer",
  class: "dialog-footer"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_vueCropper = _resolveComponent("vueCropper")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    title: "编辑头像",
    modelValue: _ctx.dialogVisibled,
    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.dialogVisibled) = $event)),
    "show-close": false,
    "close-on-click-modal": false,
    "close-on-press-escape": false,
    width: "700px"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _withDirectives(_createElementVNode("div", null, [
            _createVNode(_component_el_upload, {
              ref: "upload",
              action: "",
              style: {"text-align":"center","margin-bottom":"24px"},
              "on-change": _ctx.uploads,
              accept: "image/png, image/jpeg, image/jpg",
              "show-file-list": false,
              "auto-upload": false
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_button, {
                  slot: "trigger",
                  size: "small",
                  type: "primary",
                  ref: "uploadBtn"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("选择图片")
                  ]),
                  _: 1
                }, 512)
              ]),
              _: 1
            }, 8, ["on-change"]),
            _hoisted_3
          ], 512), [
            [_vShow, !_ctx.options.img]
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_4, [
            _createVNode(_component_vueCropper, {
              class: "crop-box",
              ref: "cropper",
              img: _ctx.options.img,
              autoCrop: _ctx.options.autoCrop,
              fixedBox: _ctx.options.fixedBox,
              canMoveBox: _ctx.options.canMoveBox,
              autoCropWidth: _ctx.options.autoCropWidth,
              autoCropHeight: _ctx.options.autoCropHeight,
              centerBox: _ctx.options.centerBox,
              enlarge: _ctx.options.enlarge,
              onRealTime: _ctx.realTime
            }, null, 8, ["img", "autoCrop", "fixedBox", "canMoveBox", "autoCropWidth", "autoCropHeight", "centerBox", "enlarge", "onRealTime"]),
            _hoisted_5
          ], 512), [
            [_vShow, _ctx.options.img]
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.previewsDiv, (item) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "avatar-right-div",
              style: _normalizeStyle(item.style)
            }, [
              _withDirectives(_createElementVNode("div", {
                class: _normalizeClass([_ctx.previews.data.div, "avatar-right-previews"]),
                style: _normalizeStyle(item.zoomStyle)
              }, [
                _createElementVNode("img", {
                  src: _ctx.previews.data.url,
                  style: _normalizeStyle(_ctx.previews.data.img)
                }, null, 12, _hoisted_7)
              ], 6), [
                [_vShow, _ctx.options.img]
              ])
            ], 4))
          }), 256)),
          _createElementVNode("div", _hoisted_8, [
            (_ctx.options.img)
              ? (_openBlock(), _createBlock(_component_el_button, {
                  key: 0,
                  type: "text",
                  onClick: _ctx.uploadPreviews
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("重新上传")
                  ]),
                  _: 1
                }, 8, ["onClick"]))
              : (_openBlock(), _createElementBlock("span", _hoisted_9, "预览"))
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _hoisted_11,
        _createElementVNode("ul", _hoisted_12, [
          _createElementVNode("li", {
            class: _normalizeClass({ active: _ctx.active == 1 }),
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.imageUrlToBase64('/static/free/header/11.png', 1)))
          }, _hoisted_14, 2),
          _createElementVNode("li", {
            class: _normalizeClass({ active: _ctx.active == 2 }),
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.imageUrlToBase64('/static/free/header/22.png', 2)))
          }, _hoisted_16, 2),
          _createElementVNode("li", {
            class: _normalizeClass({ active: _ctx.active == 3 }),
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.imageUrlToBase64('/static/free/header/33.png', 3)))
          }, _hoisted_18, 2),
          _createElementVNode("li", {
            class: _normalizeClass({ active: _ctx.active == 4 }),
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.imageUrlToBase64('/static/free/header/44.png', 4)))
          }, _hoisted_20, 2),
          _createElementVNode("li", {
            class: _normalizeClass({ active: _ctx.active == 5 }),
            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.imageUrlToBase64('/static/free/header/55.png', 5)))
          }, _hoisted_22, 2),
          _createElementVNode("li", {
            class: _normalizeClass({ active: _ctx.active == 6 }),
            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.imageUrlToBase64('/static/free/header/66.png', 6)))
          }, _hoisted_24, 2),
          _createElementVNode("li", {
            class: _normalizeClass({ active: _ctx.active == 7 }),
            onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.imageUrlToBase64('/static/free/header/77.png', 7)))
          }, _hoisted_26, 2),
          _createElementVNode("li", {
            class: _normalizeClass({ active: _ctx.active == 8 }),
            onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.imageUrlToBase64('/static/free/header/88.png', 8)))
          }, _hoisted_28, 2)
        ])
      ]),
      _createElementVNode("span", _hoisted_29, [
        _createVNode(_component_el_button, { onClick: _ctx.closeDialog }, {
          default: _withCtx(() => [
            _createTextVNode("取 消")
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: _ctx.getCrop
        }, {
          default: _withCtx(() => [
            _createTextVNode("确 定")
          ]),
          _: 1
        }, 8, ["onClick"])
      ])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}